import axios from "axios";
import { useEffect } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const money = n => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);
export function useLiveReload(load, delay = 15000) {
  useEffect(() => {
    const t = setInterval(load, delay); const onFocus = () => load(); const onVis = () => { if (document.visibilityState === "visible") load(); };
    window.addEventListener("focus", onFocus); document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onVis); };
  }, [load, delay]);
}
